import { PlatformType } from '@mm/state/model/CampaignsModel';
import moment, { Moment } from 'moment';

const map = new Map([
  ['queued', 'Queued'],
  ['delivered', 'Delivered'],
  ['unsubscribed', 'Unsubscribes'],
  ['read', 'Read'],
  ['responded', 'Replied'],
]);

export const getKeyTitle = (key: StatsKey) => {
  return map.get(key) || '';
};

export const getPlatformTitle = (platform?: PlatformType) => {
  switch (platform) {
    case 'sms':
      return 'SMS';
    case 'instagram':
      return 'INST';
    case 'facebook':
      return 'FB';
    default:
      return '';
  }
};

export const keys = Array.from(map).map(([v]) => v);

export type StatsKey =
  | string
  | 'queued'
  | 'delivered'
  | 'unsubscribed'
  | 'read'
  | 'responded';

export type StatusesEntry = Record<StatsKey, Record<PlatformType, number>>;

export type StatsType = { date: string; statuses: StatusesEntry }[];

export type DripCampaignStatsType = {
  stats: StatsType;
};

export const getTitle = (key: StatsKey, platform?: PlatformType): string => {
  return getKeyTitle(key) + ' ' + getPlatformTitle(platform);
};

export const getDatesBack = (length: number): Moment[] => {
  return Array.from({ length })
    .map((v, i) => moment().startOf('day').subtract(i, 'day'))
    .reverse();
};

export const getDatesFrom = (date: string) => {
  const today = moment().startOf('day');
  const from = moment(date).startOf('day');

  const diff = today.diff(from, 'days');

  return getDatesBack(diff);
};
